import React, { Component } from "react";
import { Placeholder } from "semantic-ui-react";
import { isEmpty } from "lodash";
import ReadAxios from "../../axiosComponent/read";

export class VehicleType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      VehicleType: null,
    };
  }

  componentDidMount() {
    this.getVehicleType();
  }

  getVehicleType = () => {
    ReadAxios({ url: `vehicleTypeMaster/${this.props.VehicleId}` })
      .then((res) => {
        return isEmpty(res.data.resultSet)
          ? "NA"
          : this.setState({
              VehicleType: res.data.resultSet[0].vehicleType,
            });
      })
      .catch((err) => {
        return "NA";
      });
  };

  render() {
    return this.state.VehicleType ? (
      <>{this.state.VehicleType}</>
    ) : (
      <Placeholder fluid>
        <Placeholder.Header>
          <Placeholder.Line />
        </Placeholder.Header>
      </Placeholder>
    );
  }
}

export default VehicleType;
